<template>
  <div>
    <div :class="{ DeleteLabel: deleteLabel }" @click="handleDelete">
      <img src="/static/images/measureActive.png" alt="" />
    </div>
  </div>
</template>
  <script>
import Bus from '../../utils/bus.js'

export default {
  data() {
    return {
      deleteLabel: 'DeleteLabel',
      labels: null,
      renderer: null,
    }
  },
  methods: {
    handleDelete() {
      if (!this.labels || this.labels.length === 0) return

      const target = this.labels[0].target
      target.parentNode.removeChild(target)

      if (this.labels[2]) {
        this.renderer[2].remove(this.labels[1])
        this.labels[2].forEach(item => this.renderer[2].remove(item))
      } else {
        this.renderer[2].remove(this.labels[1])
      }
      this.labels = []
      this.renderer[0].render(this.renderer[2], this.renderer[1])
    },
  },
  mounted() {
    this.renderer = this.$store.state.rendererRef
    Bus.$on('eventDIV', (data) => { this.labels = data })
  },
}
</script>
<style scoped lang="scss">
.DeleteLabel {
  width: 35px;
  height: 35px;
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>